import React, { Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_Xmark } from 'hosman-material';
import PropTypes from 'prop-types';

export const Modal = ({ children, isOpen, closeModal, width = 'w-full', bgOpacity = 'bg-opacity-20' }) => {
  let completeButtonRef = useRef(null)

  const handleClose = () => {
    if (closeModal) closeModal();
  };

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog initialFocus={completeButtonRef} as='div' className='relative z-40' data-testid='modal' onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className={`fixed inset-0 bg-ih-neutral ${bgOpacity}`} data-testid='background'/>
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto mt-0'>
            <div className={`m-auto ${width} flex min-h-full items-center justify-center p-4`}>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='relative transform overflow-hidden rounded-3xl bg-white shadow-xl transition-all' onClick={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}>
                  {closeModal &&
                    <div className='absolute top-3 right-3 z-10'>
                      <div className='bg-ih-indigo hover:bg-ih-indigo-90 text-white rounded-3xl w-8 h-8 text-center cursor-pointer flex items-center justify-center' ref={completeButtonRef} onClick={closeModal} data-testid='close-modal'>
                        <FontAwesomeIcon icon={S_Xmark} />
                      </div>
                    </div>
                  }
                  
                  { children }
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
};

Modal.prototype = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  width: PropTypes.string,
  bgOpacity: PropTypes.string
}
